// reactstrap components
import { Row, Col, Nav, NavItem, NavLink } from "reactstrap";
import NcentivaFooter from '../../../assets/img/footer-logo.png'
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { useMemo} from "react";
import Notify from "../../../lib/Utils/Alert";
import FileUpload from "lib/Core/Backend/Controllers/FileUpload";
import nimg from "../../../assets/img/logo192.png"

const Footer = ({token}) => {
	const supplierCtl = useMemo(() => new FileUpload(token), [token]);
	const downloadTermsandCondition = (url) => {
		const link = Object.assign(document.createElement('a'), { href: url, download: '', target: '_blank' });
		document.body.appendChild(link).click();
		document.body.removeChild(link);
	};
	const downloadFile = (FileType) => {
		supplierCtl.downloadPDFDocument(FileType,(data)=>{
			if(data && !data.error){
				downloadTermsandCondition(data?.link)
			}else{
				Notify(alert, "danger", data.error)
			}
	})       
	}
	return (
		<footer className="footer" style={{backgroundColor:"#E8EDFB"}} >
			<Row className="align-items-center justify-content-xl-between">
				<Col xl="6">
					<div className="copyright text-center text-xl-left text-muted">
						© {new Date().getFullYear()}{' '}
							<Link>Ncentiva</Link>		
					</div>
				</Col>
				<Col xl="6">
					<Nav className="nav-footer justify-content-center justify-content-xl-end mt-2">
						{" "}
						<NavItem style={{cursor:"pointer"}}>
							
						<NavLink>
						<span><img src="https://ncentiva-public.s3.us-east-2.amazonaws.com/Vector.svg" style={{height:"16px", width:"16px"}} className="me-1"/></span><Link to={"terms"}  target="_blank" onClick={(e)=>{e.preventDefault(); downloadFile('TERMS')}}>Terms of Use</Link>
						</NavLink>
							
							<NavLink >
							<span><img src="https://ncentiva-public.s3.us-east-2.amazonaws.com/Vector.svg" style={{height:"16px", width:"16px"}} className="me-1"/></span><Link to={"privacy"}  target="_blank" onClick={(e)=>{e.preventDefault();downloadFile('PRIVACY')}}>Privacy Policy</Link>
							</NavLink>{" "}
						</NavItem>
					</Nav>
					
				</Col>
				
			</Row>
		</footer>
	);
};

export default Footer;
